import { LitElement, html, css } from 'lit'
import 'bui/helpers/backbone/promises'
import 'bui/helpers/lit'
import Coll, {BusRoutes} from './models'
import './camper'
import Dialog from 'dialog'
import 'bui/elements/headers'
import 'bui/elements/paper'
import 'bui/elements/empty-state'
import 'bui/elements/btn'
import 'bui/elements/sub'
import 'bui/presenters/form/control'
import 'bui/presenters/form/controls/text-field'

import Icon from 'bui/elements/icon'

// register specific icons
Icon.register(
    require('bui/elements/icon/legacy/attention-circle.svg.html'),
    require('bui/elements/icon/legacy/ok-circled.svg.html'),
    require('bui/elements/icon/legacy/cancel-circled.svg.html'),
    ['error', require('@material-icons/svg/svg/error/baseline.svg')],
    ['bus', require(`@material-icons/svg/svg/directions_bus/baseline.svg`)],
)

import './style.less'

customElements.define('s-bus-reservation', class extends LitElement{

    static get title(){ return 'Bus'}
    static get icon(){ return 'bus'}
    static get id(){ return 'bus-reservation'}

    constructor(){
        super()
        this.routes = new BusRoutes()
        this.coll = new Coll()

        this.routes.fetch()

        // TEMP
        // this.coll.lookup('kevin.jantzer@blackstoneaudio.com').then(()=>this.update())

        this.query = new URLSearchParams(location.search)

        if( this.query.get('email') ){
            // parent email should be last
            this.email = this.query.get('email').split(',').pop()
            this.coll.lookup(this.email).then(()=>this.update())
        }
    }

    // createRenderRoot(){ return this }

    static get styles(){return css`
    
        :host {
            display: block;
            position:relative;
            padding: 0;
            /* padding: 1em; */
        }

        b-paper {
            margin-bottom: 2em;
        }

        form-control {
            display: block;
        }

        s-bus-reserve-camper {
            margin-bottom: 2em;
        }
    `}

    async findCampers(e){
        
        let email = e.currentTarget.value

        console.log(email);
        await this.coll.lookup(email)
        this.requestUpdate()
    }

    render(){return html`

        <b-paper overshadow>
            <form-control material="filled" .value=${this.email}>
                <text-field placeholder="Parent or camper email" @change=${this.findCampers}></text-field>
                <div slot="help">Lookup your camper(s) with the email you registered with</div>
            </form-control>

        </b-paper>

        <b-paper overshadow>

            <b-empty-state static md must-be="last">
                ${this.coll.email?html`Nothing found`:'Waiting to lookup'}
            </b-empty-state>

            ${this.coll.map(m=>html`
                <s-bus-reserve-camper .model=${m} .routes=${this.routes}></s-bus-reserve-camper>
            `)}

            ${this.coll.canReserve?html`
                <b-btn lg color="primary" icon="bus" @click=${this.reserve}>Reserve</b-btn>
            `:''}

        </b-paper>
    `}

    async reserve(){
        let missing = this.coll.find(m=>!m.get('_bus_route'))

        if( missing ) return

        console.log('reserver');

        let selected = await new Dialog({
            title: 'Reserve Bus',
            msg: html`Would you like to pay the bus fee now?
                <br><b-text tone="info">We will charge the card used at registration</b-text> (+4% card fee).
                <br><br>If not, you will pay your driver by <b>cash/check</b> when you arrive to board the bus. NO EXCEPTIONS!`,
            w: 400,
            btns: [{
                label: 'Reserve Only',
                val: ''
            },{
                label: 'Pay Now & Reserve',
                val: 'pay',
                color: 'primary'
            }],
            closeBtn: true
        }).modal({width: '400px'})

        if( !selected ) return

        let d = new Dialog({title: 'Reserving bus', msg: 'One moment...', icon: 'spinner', btns: false})
        d.modal({
            disableBackdropClick:true,
            closeOnEsc: false,
            disableOverscrollClose: true
        })
        try{
            await this.coll.reserve(selected.val)
        }catch(err){
            Dialog.error({title: err.name, msg: err.message}).modal()
        }
        this.update()
        d.close()
    }

})

export default customElements.get('s-bus-reservation')

// document.querySelector('#main').appendChild(document.createElement('s-bus-reservation'))